import * as ActionTypes from '../actionTypes';

// API
import * as HttpApi from '../Api/index';
export const actionTypes = ActionTypes;

//////////////////
///// GET ////////
//////////////////
export const getList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eUSER_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getProductInfo = (params) => {
	return (dispatch) => {
		return HttpApi.get('eUSER_PRODUCT_INFO', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getProductConfirmList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eUSER_PRODUCT_CONFIRM_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getProductConfirmMyList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eUSER_PRODUCT_CONFIRM_MY_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getCount = (params) => {
	return (dispatch) => {
		return HttpApi.get('GET_ACCOUNT_COUNT', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getById = (params) => {
	return (dispatch) => {
		return HttpApi.get('eUSER_GET_INFO', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getUserEventGet = (params) => {
    return (dispatch) => {
        return HttpApi.get('eUSER_EVENT_GET', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

//////////////////
///// POST ///////
//////////////////
export const create = (params) => {
	return (dispatch) => {
		return HttpApi.post('eUSER_CREATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const login = (params) => {
    return (dispatch) => {
        return HttpApi.post('eUSER_LOGIN', params)
            .then((response) => {
                dispatch({ type: ActionTypes.eSESSION, eSESSION: response.data });
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};



export const getProductConfirm = (params) => {
    return (dispatch) => {
        return HttpApi.post('eUSER_PRODUCT_CONFIRM', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

export const getProductConfirmLite = (params) => {
    return (dispatch) => {
        return HttpApi.post('eUSER_PRODUCT_CONFIRM_LITE', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

export const getProductConfirmError = (params) => {
    return (dispatch) => {
        return HttpApi.post('eUSER_PRODUCT_CONFIRM_ERROR', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

export const userProductFeed = (params) => {
    return (dispatch) => {
        return HttpApi.post('eUSER_PRODUCT_FEED', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
export const getUserProductInfo = (params) => {
	return (dispatch) => {
		return HttpApi.get('eUSER_PRODUCT_INFO', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// POST  ///////
//////////////////
export const userWeiboLogin = (params) => {
	return (dispatch) => {
		return HttpApi.post('eUSER_WEIBO_LOGIN', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};



//////////////////
///// PUT  ///////
//////////////////
export const updateAdmin = (params) => {
	return (dispatch) => {
		return HttpApi.post('eUSER_UPDATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const updateStatus = (params) => {
	return (dispatch) => {
		return HttpApi.put('eUSER_UPDATE_EUserStatus', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const updateUser = (params) => {
    return (dispatch) => {
        return HttpApi.put('eUSER_UPDATE', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

//////////////////
///// DELETE /////
//////////////////
export const remove = () => {
    return (dispatch) => {
        return HttpApi.del('eUSER_DELETE')
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

//////////////////
/// FUNCTIONS ////
//////////////////
export const session = () => {
	return (dispatch) => {
		return HttpApi.get('GET_AUTH_SESSION')
			.then((response) => {
				console.log('get-auth-session', response);
				dispatch({ type: ActionTypes.LOGIN, author: response.data });
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

